/**
 * 基礎適配器類別
 * 定義所有適配器必須實作的介面
 */

export class BaseAdapter {
  /**
   * 新增收件人/與會人員
   * @param {Array} recipients - 收件人列表，格式：[{displayName: string, emailAddress: string}]
   * @param {string} type - 類型："to" | "cc" | "bcc" | "attendees"
   * @returns {Promise<void>}
   */
  async addRecipients(recipients, type) {
    throw new Error('addRecipients method must be implemented by subclass');
  }

  /**
   * 檢查當前環境是否支援此適配器
   * @returns {boolean}
   */
  isSupported() {
    throw new Error('isSupported method must be implemented by subclass');
  }

  /**
   * 獲取適配器名稱
   * @returns {string}
   */
  getName() {
    throw new Error('getName method must be implemented by subclass');
  }
}

